import { CloudArrowDownIcon, Typography, emptyFragment } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import ExternalLink from '../../../Native/AEP/ExternalLink';
import { T } from '../../../Translations';
import { ExperienceDictionaryEntryResponse } from '../../ExperiencesDictionary/Types';

interface Props<T> {
  experience: ExperienceDictionaryEntryResponse;
}

function DownloadOverview<T>({ experience }: Props<T>) {
  return experience.links.overviewPdf
    .map((pdfLink) => (
      <div className="flex items-center gap-x-2.5">
        <CloudArrowDownIcon color="black" size="md" />
        <ExternalLink
          href={pdfLink.href}
          data-intercom-target="discovery-portal-download-overview-pdf"
        >
          <Typography color="teal" variant="bodyMedium">
            <T kind="Download Program Overview" />
          </Typography>
        </ExternalLink>
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(DownloadOverview);
